import { useGenericFormValidator } from "../../../../util/genericFormValidator";
import { Alert } from '../../../../util/Alert'
import { UpdatePasswordApi } from '../../../../service/controller/AuthController'

export const useChangePassword = () => {

    const initialForm = {
        currentPassword: ''
    }

    const validationRules = {
        currentPassword: { required: true },
    }

    const { form, errors, handleChange, validate } = useGenericFormValidator(initialForm, validationRules);

    const onChangePassword = (newPassword, confirmNewPassword) => {
        if (validate()) {
            UpdatePasswordApi({
                "senhaAtual": form.currentPassword,
                "novaSenha": newPassword,
                "confirmacaoNovaSenha": confirmNewPassword
            }, () => {
                Alert('Senha atualizada com sucesso!');
            })
        }
    }

    return {
        currentPassword: form.currentPassword,
        handleChange,
        errors,
        onChangePassword
    }
}